import React from "react";
import { LeaveReviewBox, NoTripText } from "./../Elements"
import { responseMessages } from "../../../data";

const NoReviews = () => {
    return <LeaveReviewBox >
        <NoTripText>{responseMessages.noReviewsReceived}</NoTripText>
    </LeaveReviewBox >
}

export default NoReviews